import { createSelector } from 'reselect';
import { RootState, RoleManagementState } from 'data'; // Adjust paths as needed

// Base selector
const roleManagementSelector = (state: RootState): RoleManagementState => state.roleManagement;

// Generic selector factory
const createRoleManagementSelector = <K extends keyof RoleManagementState>(
  field: K
): ((state: RootState) => RoleManagementState[K]) =>
  createSelector([roleManagementSelector], (state) => state[field]);

export const selectSelectedRole = createRoleManagementSelector('selectedRole');
export const selectSelectedRoleTab = createRoleManagementSelector('selectedRoleTab');
